import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { getCorporateUrl, getFlipper } from 'store/modules/company';
import { FLIPPER_VOYAGER_ADMIN_DOMAIN_SSL_SETTINGS } from '../../../../../constants/flippers';
import AdminSettings from '../components/AdminSettings';

export default connect(
  state => ({
    corporateUrl: getCorporateUrl(state),
    domainSSLFlipper: getFlipper(state, FLIPPER_VOYAGER_ADMIN_DOMAIN_SSL_SETTINGS),
  }),
  { pushRoute: push },
)(AdminSettings);
